module.exports = __webpack_public_path__ + "img/icon-arrow-flat.02865a8e.svg";